<template>
  <sl-dropdown distance="5" :placement="placement" hoist>
    <sl-button slot="trigger" data-testid="three-dots-vertical" :size="size"
      ><sl-icon
        :style="size === 'small' ? `font-size: 14px` : `font-size: 18px`"
        name="three-dots-vertical"
    /></sl-button>
    <slot name="menu"></slot>
  </sl-dropdown>
</template>

<script setup>
defineProps({
  placement: {
    type: String,
    default: 'bottom-start'
  },
  size: {
    type: String,
    default: 'medium'
  }
})
</script>

<style lang="postcss" scoped>
sl-button {
  &::part(base) {
    width: 40px;
    height: 40px;
    border-color: var(--sl-color-neutral-300);
  }

  &[size='small'] {
    &::part(base) {
      width: 30px;
      height: 30px;
    }
  }

  &[size='large'] {
    &::part(base) {
      width: 50px;
    }
  }

  &::part(label) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--sl-spacing-small);
  }
}

:deep(sl-menu-item) {
  &::part(base) {
    padding-left: var(--sl-spacing-medium);
    padding-right: var(--sl-spacing-medium);
    font-size: var(--sl-font-size-small);
  }
  &::part(checked-icon),
  &::part(submenu-icon) {
    display: none;
  }

  /* this is covering usage of phosporicons on menu item  because slot suffix/prefix is not applied for the icon */
  &::part(label) {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
